import { render, staticRenderFns } from "./TextLinkHeader.vue?vue&type=template&id=2626c6dc&"
import script from "./TextLinkHeader.vue?vue&type=script&lang=ts&"
export * from "./TextLinkHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports